<template>
  <div class="wrapper home">
    <div class="wrapper home_content">
      <div class="contentwidth1">
        <el-row :gutter="10" style="margin: 10px 0">
          <el-col :span="8">
            <div class="flex title1 jianbian">
              <div class="flex title_left">
                <div class="title_text2">机构简介</div>
              </div>
              <el-link
                :underline="false"
                @click="goContent('/center?id=2_1&index=0')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="home_center_info">
                <div
                  class="home_center_synopsis"
                  v-html="clinicalCenter.content"
                ></div>
                <div class="float:right">
                  <div @click="lookMore('/center?id=2_1&index=0')">
                    <span
                      style="
                        font-size: 12px;
                        cursor: pointer;
                        color: #018277;
                        font-weight: bold;
                      "
                      >... ...[详细]</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="8" style="padding: 0 18px">
            <div class="flex title jianbian">
              <div class="flex title_left">
                <div class="title_text2">新闻动态</div>
              </div>
              <el-link
                :underline="false"
                @click="goContent('/party/partyContent?id=3_1&index=0')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="party_list">
                <div
                  class="flex party_list_in"
                  v-for="(item, index) in menuList"
                  :key="index"
                  @click="
                    $store.actions.goInfo(
                      item.id,
                      '/front/handleGuide/info/',
                      '党建动态',
                      2
                    )
                  "
                >
                  <div class="notice_li_tips"></div>
                  <div class="party_list_text">
                    <span style="font-weight: bold; font-size: 16px"></span>
                    {{ item.title }}
                  </div>
                  <div class="party_list_date">
                    {{ item.createTime.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex title jianbian">
              <div class="flex title_left">
                <div class="title_text2">通知公告</div>
              </div>
              <el-link :underline="false" @click="goContent('/learn')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="party_list">
                <div
                  class="flex party_list_in"
                  v-for="(item, index) in partyList"
                  :key="index"
                  @click="
                    $store.actions.goInfo(
                      item.id,
                      '/front/handleGuide/info/',
                      '通知公告',
                      1
                    )
                  "
                >
                  <div class="notice_li_tips"></div>
                  <div class="party_list_text">
                    <span style="font-weight: bold; font-size: 16px"></span>
                    {{ item.title }}
                  </div>
                  <div class="party_list_date">
                    {{ item.createTime.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 30px">
          <el-col :span="8">
            <div class="flex title jianbian">
              <div class="flex title_left">
                <div class="title_text2">办事指南</div>
              </div>
              <el-link
                :underline="false"
                @click="goContent('/handleguide?id=13_1&index=0')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="party_list">
                <div
                  class="flex party_list_in"
                  v-for="(item, index) in guidanceList"
                  :key="index"
                  @click="
                    $store.actions.goInfo(
                      item.id,
                      '/front/handleGuide/info/',
                      '办事指南',
                      2
                    )
                  "
                >
                  <div class="notice_li_tips"></div>
                  <div class="party_list_text">
                    <span style="font-weight: bold; font-size: 16px"></span>
                    {{ item.title }}
                  </div>
                  <div class="party_list_date">
                    {{ item.createTime.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8" style="padding: 0 18px">
            <div class="flex title jianbian">
              <div class="flex title_left">
                <div class="title_text2">政策法规</div>
              </div>
              <el-link
                :underline="false"
                @click="goContent('/enchiridion?id=4_1&index=0')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="party_list">
                <div
                  class="flex party_list_in"
                  v-for="(item, index) in lawsList"
                  :key="index"
                  @click="goto(item)"
                >
                  <div class="notice_li_tips"></div>
                  <div class="party_list_text">
                    <span style="font-weight: bold; font-size: 16px"></span>
                    {{ item.title }}
                  </div>
                  <div class="party_list_date">
                    {{ item.createTime.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex title jianbian">
              <div class="flex title_left">
                <div class="title_text2">志愿者招募</div>
              </div>
              <el-link :underline="false" @click="goContent('/recruit')"
                >更多》</el-link
              >
            </div>
            <div class="flex wrapper home_center">
              <div class="party_list">
                <div
                  class="flex party_list_in"
                  v-for="(item, index) in recruitList"
                  :key="index"
                  @click="goDetails(item.id)"
                >
                  <div class="notice_li_tips"></div>
                  <div class="party_list_text">
                    <span style="font-weight: bold; font-size: 16px"></span>
                    {{ item.projectName }}
                  </div>
                  <div class="party_list_date">
                    {{ item.publishTime.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="wrapper home_link">
      <div style="">
        <div class="home_title1">
          <div class="home_title1_name">相关链接</div>
          <div
            class="flex home_title1_border"
            style="background-color: transparent"
          >
            <div class="home_title1_border_in"></div>
          </div>
          <div class="home_title1_English">RELATED LINKS</div>
        </div>
      </div>
      <div class="flex contentwidth1 home_link_info">
        <a
          v-for="(relatedLinksItem, index) in relatedLinksList"
          :key="index"
          :href="getLinkUrl(relatedLinksItem.linkUrl)"
          target="_blank"
          class="flex home_link_in"
          ><i class="el-icon-caret-right" style="color: #018277"></i
          >{{ relatedLinksItem.title }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getmenu,
  bannerQuery,
  linkQuery,
  indexHandleGuide,
  meetingnotice,
  indexPoliceRegulation,
  listIndexTbrecruit,
} from "@/request/api";
import Header from "@/components/header.vue";
import img from "./center/img.vue";
export default {
  components: { img, Header },
  name: "NewHelloWorld",
  data() {
    return {
      activeNameNotice: 0,
      bannerList: [], //banner图
      newsList: [
        { menuName: "通知公告", id: "5_1", newsContent: [], totalCountVal: "" },
        { menuName: "新闻动态", id: "3_1", newsContent: [], totalCountVal: "" },
        { menuName: "政策法规", id: "4_1", newsContent: [], totalCountVal: "" },
      ], //新闻资讯tab列表
      policyList: [], //政策法规列表
      policyContent: [], //政策法规列表-内容
      policyIndex: 0,
      clinicalCenter: "", //中心介绍-临床试验中心
      relatedLinksList: [], //相关链接
      educationList: [], //教育培训
      suspensionContent: "",
      isSuspension: true,
      timer: "",
      sxVal: 0,
      syVal: 0,
      recruitList: [], //受试者招募
      partyList: [], //通知公告
      menuList: [], //新闻动态
      guidanceList: [], //办事指南
      lawsList: [], //法规文件
      bannerHeight: "",
    };
  },
  created() {
    this.bannerQuery_Fun(1, "1_1"); //banner图
    this.bannerQuery_Fun(2, "1_2"); //专委会介绍
    this.getmenu_Fun(4); //政策法规
    this.getmenu_Fun(3); //公告通知
    this.linkQuery_Fun("11_1", 1); //链接管理-相关链接
    this.handleGuide_Fun(5, "5_1", 5, 0); //学术活动
    this.handleGuide_Fun(8, "8_1", 4, "-1"); //教育培训
    this.handleGuide_Fun(8, "8_1", 4, "-1"); //公告通知
    this.linkQuery_Fun("12_1", 2); //悬浮窗
    this.getnews();
  },
  mounted() {},
  methods: {
    goContent(url) {
      this.$router.push({
        path: url,
      });
    },
    // 获取列表
    getnews() {
      let data = {
        pageSize: 7,
        pageNumber: 1,
      };
      listIndexTbrecruit(data).then((res) => {
        this.recruitList = res.data.data.list;
      });
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    getLinkUrl(v) {
      console.log(v.indexOf("http") != -1);
      if (v.indexOf("http") != -1) {
        return v;
      } else {
        return "http://" + v;
      }
    },
    getmenu_Fun(parentMenuId) {
      let params = {
        parentMenuId: parentMenuId,
        pageSize: 100,
        pageNumber: 1,
      };
      let data = {
        pageSize: 7,
        pageNumber: 1,
      };
      getmenu(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (parentMenuId == 4) {
              data.belongSystemId = "1";
              data.blongToMenu = "4_1";
              //政策法规
              indexPoliceRegulation(data).then((res) => {
                this.lawsList = res.data.data.list;
              });
            } else if (parentMenuId == 3) {
              this.partyList = res.data.data.list;
              this.handleGuide_Fun(3, "5_1", 7);
              this.handleGuide_Fun(0, res.data.data.list[0].id, 7);
              this.handleGuide_Fun(13, "13_1", 7);
            }
          }
        })
        .catch((err) => {});
    },
    bannerQuery_Fun(type, blongToMenu) {
      let params = {};
      if (type == 1) {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 10,
          pageNumber: 1,
          type: type,
        };
      } else {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 1,
          pageNumber: 1,
        };
      }
      bannerQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (type == 1) {
              this.bannerList = res.data.data.list;
            } else if (type == 2) {
              this.clinicalCenter = res.data.data.list[0];
            }
          }
        })
        .catch((err) => {});
    },
    linkQuery_Fun(blongToMenu, type) {
      // 相关链接
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 100,
        pageNumber: 1,
        type: type,
      };
      linkQuery(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (type == 1) {
              // 相关链接
              this.relatedLinksList = res.data.data.list;
            } else if (type == 2) {
              this.suspensionContent = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    goto(v) {
      console.log(v);
      let titleName = "";
      if (v.blongToMenu == "4_1") {
        titleName = "药监局政策法规";
      } else if (v.blongToMenu == "4_2") {
        titleName = "卫健委政策法规";
      } else {
        titleName = "国际政策法规及其它";
      }
      this.$store.actions.goInfo(
        v.id,
        "/front/handleGuide/info/",
        titleName,
        1
      );
    },
    handleGuide_Fun(num, blongToMenu, pageSize, index) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: pageSize,
        pageNumber: 1,
      };
      indexHandleGuide(params)
        .then((res) => {
          if (res.data.code == 200) {
            if (num == 5 || num == 6 || num == 7) {
              this.newsList[index].newsContent = res.data.data.list;
              this.newsList[index].totalCountVal = res.data.data.totalCount;
              // this.$set(this.newsList, index, this.newsList[index]);
            } else if (num == 8) {
              this.educationList = res.data.data.list;
            } else if (num == 4) {
              this.policyContent = res.data.data.list;
            } else if (num == 3) {
              this.partyList = res.data.data.list;
            } else if (num == 0) {
              this.menuList = res.data.data.list;
            } else if (num == 13) {
              this.guidanceList = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    // indexHandleGuide
    lookMore(url) {
      this.$router.push({ path: url });
    },
    goDetails(id) {
      this.$router.push({
        path: "/recruit/details",
        query: {
          id: id,
        },
      });
    },
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
};
</script>

<style>
.home_notice .el-tabs__header {
  position: absolute;
  top: -90px;
  left: 0;
}
.home_notice .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.home_notice .el-tabs__active-bar {
  background-color: #018277;
  width: 124px;
}
.home_notice .el-tabs__item.is-active,
.home_notice .el-tabs__item:hover {
  color: #018277;
}
.home_notice .el-tabs__item.is-active {
  font-size: 26px;
  font-weight: bold;
}
.home_notice .el-tabs__item {
  font-size: 16px;
}
.tipsclass {
  margin-left: -100px !important;
}
</style>
<style scoped>
.home_content {
  margin-top: 30px;
}
.home_title2 {
  height: 40px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}
.home_title2_name {
  font-size: 26px;
  color: #1a1a1a;
}
.home_title2_btn {
  width: 280px;
  height: 50px;
  background: url(../../static/images/home/titleBtn.png) no-repeat;
  background-size: cover;
  padding-left: 22px;
  align-items: center;
  color: #fff;
  line-height: 50px;
}
.home_notice {
  position: relative;
}
.home_notice_content {
  min-height: 444px;
  justify-content: flex-end;
  position: relative;
  flex-wrap: wrap;
}
.home_notice_content_mian {
  flex-direction: column;
}
.home_notice_content_info {
  width: 610px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.home_notice_content1 {
  width: 490px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_notice_content2 {
  width: 290px;
}
.home_notice_content3 {
  width: 610px;
}
.home_notice_ {
  cursor: pointer;
}
.home_notice_:nth-child(4) {
  border-top: 1px solid #cccccc;
  margin-top: 35px;
}
.home_notice_:last-child {
  margin-bottom: 10px;
}
.home_notice_left {
  width: 490px;
}
.home_notice_img {
  width: 100%;
  height: 300px;
  position: relative;
}
.home_notice_date1 {
  padding: 15px 20px;
  background-color: #018277;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}
.home_notice_date2 {
  padding: 8px 20px;
  background-color: #018277;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}
.home_notice_left_text {
  width: 100%;
  height: 90px;
  background-color: #f8f8f8;
  padding: 0 22px;
  line-height: 30px;
  font-size: 16px;
  color: #4d4d4d;
  align-items: center;
}
.home_notice_left_content {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 25px;
}
.home_notice_right {
  width: 610px;
  height: auto;
}
.home_notice_show_in {
  width: 290px;
  height: auto;
}
.home_notice_show_img {
  width: 100%;
  height: 178px;
  position: relative;
}
.home_notice_show_title {
  width: 100%;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #4d4d4d;
  margin-top: 30px;
}
.home_notice_list_in {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #cccccc;
  align-items: center;
  justify-content: space-between;
}
.home_notice_list_title {
  width: 480px;
  font-size: 14px;
  color: #4d4d4d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_notice_list_date {
  font-size: 14px;
  color: #4d4d4d;
}
.home_title1 {
  width: 1400px;
  margin: auto;
  height: 110px;
  flex-wrap: wrap;
  margin-top: 40px;
  padding-top: 20px;
}
.home_title1.home_title1_wrapper {
  height: 200px;
  padding-bottom: 60px;
  background: url(../../static/images/home/educationTrainingBg.png) no-repeat;
  background-size: cover;
}
.home_title1_name {
  width: 100%;
  font-size: 26px;
  color: #1a1a1a;
  /* text-align: center; */
}
.home_title1_border {
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  /* justify-content: center; */
  margin: 10px 0;
}
.home_title1_border_in {
  width: 56px;
  height: 1px;
  background-color: #018277;
}
.home_title1_English {
  width: 100%;
  font-size: 14px;
  color: #1a1a1a;
  /* text-align: center; */
}
.home_title1_wrapper .home_title1_name,
.home_title1_wrapper .home_title1_English {
  color: #fff;
}
.home_title1_wrapper .home_title1_border {
  background-color: transparent;
}
.home_title1_wrapper .home_title1_border_in {
  background-color: #fff;
}
.home_center {
  height: 270px;
  border-radius: 10px;
  border: 1px solid #dbd6d6;
  padding: 10px;
  justify-content: space-between;
}
.home_center_img {
  height: 250px;
}
.home_center_info {
  width: 650px;
  height: 250px;
}
.home_center_synopsis {
  height: 225px;
  overflow: hidden;
}
.home_education {
  padding-top: 290px;
  position: relative;
}
.home_education_photo1 {
  width: 100%;
  height: 290px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_education_photo2 {
  width: 360px;
  height: 240px;
  position: relative;
  margin-right: 62px;
}
.home_education_photo2:last-child {
  margin-right: 0;
}
.home_education_first {
  width: 100%;
  height: 290px;
  background-color: #fff;
  box-shadow: 0px 2px 18px 0px rgba(126, 126, 126, 0.24);
  margin-top: -60px;
  padding: 33px 50px 33px 70px;
  justify-content: space-between;
}
.home_education_img {
  width: 360px;
  height: 226px;
  position: relative;
}
.home_education_info {
  width: 675px;
  padding-top: 10px;
  align-content: space-between;
  flex-wrap: wrap;
}
.home_education_title {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #4c4c4c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
.home_education_synopsis {
  font-size: 12px;
  line-height: 28px;
  color: #4c4c4c;
  margin-top: 15px;
}
.home_education_btn {
  width: 100px;
  height: 28px;
  background-color: #5bafbc;
  border-radius: 2px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-size: 14px;
  margin-top: 30px;
  cursor: pointer;
}
.home_education_photo_in {
  width: 360px;
  height: 240px;
  position: relative;
  cursor: pointer;
}
.home_education_photo_title {
  width: 360px;
  height: 44px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url(../../static/images/common/bg.png);
  text-align: center;
  padding: 0 10px;
  line-height: 44px;
  color: #fff;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_education_photo_in:hover .home_education_photo_title {
  background: url(../../static/images/common/bg1.png);
}
.home_regulations_nav {
  height: 50px;
  background-color: #018277;
}
.home_regulations_nav_in {
  width: 33.33%;
  height: 50px;
  position: relative;
  cursor: pointer;
}
.home_regulations_nav_num {
  width: 50px;
  height: 50px;
  background-color: #027268;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_regulations_nav_title {
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  margin-left: 70px;
}
.home_regulations_nav_hot .home_regulations_nav_num {
  height: 73px;
  background-color: #09a799;
  font-weight: bold;
  font-size: 20px;
  line-height: 73px;
}
.home_regulations_nav_hot .home_regulations_nav_title {
  font-weight: bold;
}
.home_regulations {
  flex-wrap: wrap;
  margin-top: 60px;
  padding-bottom: 75px;
}
.home_regulations_in {
  border-right: 1px solid #cccccc;
  padding-top: 45px;
  cursor: pointer;
}
.home_regulations_in:nth-child(1),
.home_regulations_in:nth-child(2),
.home_regulations_in:nth-child(3) {
  border-bottom: 1px solid #cccccc;
  padding-top: 0;
  padding-bottom: 45px;
}
.home_regulations_in:nth-child(1),
.home_regulations_in:nth-child(4) {
  width: 382px;
  padding-right: 45px;
}
.home_regulations_in:nth-child(2),
.home_regulations_in:nth-child(5) {
  width: 435px;
  padding-left: 45px;
  padding-right: 45px;
}
.home_regulations_in:nth-child(3),
.home_regulations_in:nth-child(6) {
  width: 383px;
  padding-left: 45px;
  border-right: none;
}
.home_regulations_title {
  width: 100%;
  height: 20px;
  font-size: 16px;
  color: #1a1a1a;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_regulations_in:hover .home_regulations_title {
  color: #018277;
}
.home_regulations_date {
  font-size: 12px;
  color: #333;
  margin: 20px 0 15px;
}
.home_regulations_synopsis {
  font-size: 12px;
  color: #999;
  line-height: 20px;
}
.home_link {
  background-color: #fafafa;
  padding-bottom: 70px;
}
.home_link_info {
  flex-wrap: wrap;
}
.home_link_in:nth-child(1) {
  margin-left: 0;
}
.home_link_in {
  display: block;
  width: 250px;
  height: 40px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(126, 126, 126, 0.17);
  padding: 0 5px;
  margin-bottom: 12px;
  margin-left: 40px;
  align-items: center;
  cursor: pointer;
  color: #4d4d4d;
  font-size: 14px;
  padding: 0 5px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_link_in:nth-child(4n) {
  margin-right: 0;
}
.home_link_in:hover {
  color: #018277;
}
.home_synopsis_more {
  height: 28px;
  background-color: #018277;
  border-radius: 100px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  line-height: 28px;
  align-items: center;
  color: #fff;
  cursor: pointer;
  margin-top: 20px;
}
.home_synopsis_more i {
  font-size: 20px;
}
.home_synopsis_more span {
  margin-left: 8px;
}
.suspension {
  width: 200px;
  height: 112px;
  position: fixed;
  top: 220px;
  left: 137px;
  z-index: 10;
  cursor: pointer;
}
.suspension a {
  display: block;
  width: 200px;
  height: 112px;
}
.suspension_close {
  width: 25px;
  height: 25px;
  font-size: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  background: url(../../static/images/common/bg.png);
  text-align: center;
  line-height: 25px;
}
.notice_li_tips {
  margin-top: 15px;
  width: 6px;
  height: 6px;
  background: #018277;
  border-radius: 100px;
  /* margin: 0 20px 0 14px; */
}
.home_notice_date3 {
  padding: 2px 5px;
  background-color: #018277;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  color: #fff;
}
.party_list {
  width: 100%;
}
.party_list_in {
  height: 35px;
  width: 100%;
  border-bottom: 1px dashed #e0e0e0;
  justify-content: space-between;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #4d4d4d;
  cursor: pointer;
}
.party_list_text {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.party_list_date {
  margin-left: 10px;
}
.notice_content_ul {
  width: 100%;
  margin-top: 40px;
}
.notice_content_ul li {
  display: flex;
  align-items: center;
  height: 40px;
}
.notice_content_in {
  width: 670px;
  height: 40px;
  border-bottom: 1px dashed #e0e0e0;
  display: flex;
  justify-content: space-between;
}
.notice_content_ul li:last-child .notice_content_in {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/view/newHome.vue